import styled from '@emotion/styled';

// Sets the CSS using the theme values for the contents context so by
// default it matches the rest of the site
const ContentThemeStyling = styled.div`
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.fontSize_base};
  h1 {
    color: ${props => props.theme.h1_color};
    font-size: ${props => props.theme.h1_fontSize};
    font-weight: ${props => props.theme.h1_fontWeight};
    line-height: ${props => props.theme.lineHeight_heading};
    margin-top: 0;
    margin-bottom: ${props => props.theme.space_stack_sm};
  }
  h2 {
    color: ${props => props.theme.h2_color};
    font-size: ${props => props.theme.h2_fontSize};
    font-weight: ${props => props.theme.h2_fontWeight};
    line-height: ${props => props.theme.lineHeight_heading};
    margin-top: 0;
    margin-bottom: ${props => props.theme.space_stack_sm};
  }
  h3 {
    color: ${props => props.theme.h3_color};
    font-size: ${props => props.theme.h3_fontSize};
    font-weight: ${props => props.theme.h3_fontWeight};
    line-height: ${props => props.theme.lineHeight_heading};
    margin-top: 0;
    margin-bottom: ${props => props.theme.space_stack_sm};
  }
  p {
    color: ${props => props.theme.color};
    font-size: ${props => props.theme.fontSize_prose};
    font-weight: ${props => props.theme.fontWeight_regular};
    line-height: ${props => props.theme.lineHeight_prose};
    margin-top: 0;
    margin-bottom: ${props => props.theme.space_stack_md};
  }
`;

// Overrides the default Quill styles with elements from our theme
// We use the Quill 'snow' style as the base
// See node_modules/react-quill/dist/quill.snow.css for the default CSS
// This is intended to be combined with the ContentThemeStyling above
export const QuillStyleOverride = styled.div`
  .ql-container {
    box-sizing: border-box;
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme.fontSize_base};
  }
`;

export default ContentThemeStyling;
